/**
 * Created by Rodrigo Quesada on 30/04/17.
 */
import {Directive, ElementRef, Input} from '@angular/core';
import {AbstractControl, NG_VALIDATORS} from '@angular/forms';
import {CustomValidator, ValidationError} from '../custom-validator.class';
import {ValidationMessage} from '../form-validator.class';
import {Moment} from 'moment';
import {formatMonthDayYear, formatMonthYear} from '../../../../pages/shared/utils';

//region Other Classes
enum ElementType {
    DATE_PICKER = 1,
    MONTH_PICKER
}
//endregion

@Directive({
    selector: 'my-datepicker[myIsAfter],my-datepicker[myIsBefore],my-month-picker[myIsAfter],my-month-picker[myIsBefore]',
    providers: [{provide: NG_VALIDATORS, useExisting: IsAfterValidatorDirective, multi: true}]
})
export class IsAfterValidatorDirective implements CustomValidator {

    @Input('myIsAfter') afterDateField: string;
    @Input('myIsBefore') beforeDateField: string;
    @Input('myIsBeforePresent') beforeUpToPresent: string;

    _elementType: ElementType;

    constructor(elementRef: ElementRef) {
        this._elementType = elementRef.nativeElement.nodeName.toLowerCase() === 'my-datepicker' ? ElementType.DATE_PICKER : ElementType.MONTH_PICKER;
    }

    validate(control: AbstractControl) {
        let formErrors: { [key: string]: any } = {};
        let fromDate = control.value;
        if (fromDate != null && this.beforeUpToPresent != null) {
            let upToPresent = control.root.get(this.beforeUpToPresent);
            if (upToPresent.value && fromDate.isAfter(new Date())) {
                    formErrors.isBefore = new ValidationError(`From date in future. Save to continue.`);
            }
        }

        if (this.afterDateField) {
            let afterDateField = control.root.get(this.afterDateField);
            if (afterDateField) {
                const date: Moment = control.value;
                const afterDate: Moment = afterDateField.value;

                if (date && afterDate && date.isBefore(afterDate)) {
                    formErrors.isAfter = new ValidationError(this._ErrorMessage(afterDate), true);
                }
            }
        }
        else if (this.beforeDateField) {
            let beforeDateField = control.root.get(this.beforeDateField);
            if (beforeDateField) beforeDateField.updateValueAndValidity();
        }

        return formErrors;
    }

    private _ErrorMessage(afterDate: Moment): ValidationMessage {
        return new ValidationMessage(`Date should be after ${
            this._elementType === ElementType.DATE_PICKER ? formatMonthDayYear(afterDate) : formatMonthYear(afterDate)
            }.`, '');
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/forms/validation/date/is-after-validator.directive.ts